import React, { ReactNode, useEffect } from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { usersThunkActions } from "../../redux/actions/users";
import { IAppState } from "../../redux/reducers";
import { routeUtils } from "utils/route-utils";

const mapStateToProps = (state: IAppState) => {
  return {
    user: state.users.currentUser,
    expired: state.users.sessionExpired,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>,
) => {
  return {
    getCurrentUser: () => dispatch(usersThunkActions.getCurrentUser()),
  };
};

interface IRequireAuthProps
  extends
    ReturnType<typeof mapStateToProps>,
    ReturnType<typeof mapDispatchToProps> {
  children: ReactNode;
  redirectTo: string;
}

export const RequireAuth = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: IRequireAuthProps) => {
  useEffect(() => {
    if (!props.user) {
      props.getCurrentUser();
    }

    // eslint-disable-next-line
  }, []);

  let isAuthenticated = !!props.user && !props.expired;
  let location = useLocation();

  // Check if user needs MFA setup (only if MFA is not enabled yet)
  const needsMfaSetup = props.user && props.user.mfaEnabled && props.user.needsMfaSetup;

  // Don't redirect to MFA setup if we're already on the MFA verification page
  const isOnMfaVerificationPage = location.pathname === routeUtils.getRouteToMfaVerification();

  if (!isAuthenticated) {
    return <Navigate to={props.redirectTo} state={{ from: location }} />;
  }

  if (needsMfaSetup && !isOnMfaVerificationPage) {
    return (
      <Navigate
        to={routeUtils.getRouteToMfaVerification()}
        state={{ from: location }}
        replace
      />
    );
  }

  return <>{props.children}</>;
});
